import { Map, Record } from 'immutable'
import { createSelector } from 'reselect'
import * as cartActions from '../cart/actions'
import * as actions from './actions'
import { ENTITY_CLASSNAMES } from './base'
import { getEntity } from './selectors/base'

const InitialState = Record({
  ...ENTITY_CLASSNAMES.reduce((map, classname) => {
    map[classname] = Map()
    return map
  }, {})
})

const reducer = (state = new InitialState(), action) => {
  switch (action.type) {
    case actions.CACHE_ENTITIES:
      return state.mergeWith(
        (oldEntities, newEntities) => oldEntities.merge(newEntities),
        action.entities
      )
    // Item id is used to patch entities Item state until we disableSingleInstance in parse.
    case cartActions.REMOVE_MARKET_RESERVATION_SUCCESS:
      return state.deleteIn(['Item', action.itemId, 'reservations'])
    default:
      return state
  }
}

export default reducer

export const ownItemsSelector = createSelector(
  [getEntity('Item'), (_, userId) => userId],
  (items, userId) => items.filter((item) => item.get('user') === userId)
)

export const ownBagsSelector = createSelector(
  [getEntity('Bag'), (_, userId) => userId],
  (bags, userId) => bags.filter((bag) => bag.get('user') === userId)
)

export const ownContainerOrderSelector = createSelector(
  [getEntity('ContainerOrder'), (_, userId) => userId],
  (containerOrders, userId) =>
    containerOrders
      .filter((containerOrder) => containerOrder.get('user') === userId)
      .sortBy(
        (containerOrder) => containerOrder.get('createdAt'),
        (a, b) => new Date(b) - new Date(a)
      )
)

export const itemClaimedSelector = createSelector(
  [getEntity('ItemClaim'), (_, item) => item, getEntity('BalanceTransaction')],
  (claims, item, balanceTransactions) =>
    claims.find(
      (claim) =>
        claim.get('item') === item.get('objectId') &&
        claim.get('type') === 'claim' &&
        (balanceTransactions.find(
          (transaction) =>
            transaction.get('type') === 'itemClaimedCommissionReduction' &&
            transaction.get('item') === item.get('objectId')
        ) ||
          item.get('itemStatus') === 'skänkt')
    )
)
